// extracted by mini-css-extract-plugin
export default {"ConfirmButton":"ModalCommon_ConfirmButton__tVeVP","CornerContainer":"ModalCommon_CornerContainer__7DrxZ","CloseButton":"ModalCommon_CloseButton__HhHVW"};